export default [
  {
    path: "/harga-pasar",
    component: () => import("@/pages/pasar/pasar-list.vue"),
    meta: {
      requiredLevel: ["admin", "perindag"],
    },
  },
  {
    path: "/harga-pasar/import",
    component: () => import("@/pages/pasar/pasar-import.vue"),
    meta: {
      requiredLevel: ["admin", "perindag"],
    },
  },
];
